import React from "react"
import { IconSeeker } from "@ui-seeker/core"
import { AppBulkEditAction, AppDialogCancel } from "@components"
import { autoEuropeProviderNormalizationDrawerData, autoEuropeProviderNormalizationDrawerErrors, clearAutoEuropeProviderNormalizationSignals } from "Pages/AutoEuropeTool/ProviderNormalization/@signals"

export default function AutoEuropeProviderNormalizationFooter({ onSubmit, isLoading }) {
	return <>
		<AppDialogCancel onClick={clearAutoEuropeProviderNormalizationSignals}/>
		<AppBulkEditAction
			loading={isLoading}
			startIcon={<IconSeeker icon="floppy-disk"/>}
			disabled={!Object.values(autoEuropeProviderNormalizationDrawerErrors.value).every(a => a)}
			onClick={() => onSubmit(autoEuropeProviderNormalizationDrawerData.value)}
		>
			Save
		</AppBulkEditAction>
	</>
}
